import React from 'react';
import './ShadowBoxes.css';

export default function ShadowBoxMd({ children }) {
	return <div className='mdShadowBox shadow-lg my-2 p-3 mx-auto'>{children}</div>;
}
